import { useParams } from "react-router-dom";
import EmailTemplatesService from "../../../services/EmailTemplatesService";
import { EmailTemplate } from "../../../models";
import { useEffect, useState } from "react";
import NotFound from "../../../components/not-found";
import Breadcrumbs from "../../../components/breadcrumbs";
import EmailTemplateEditForm from "./ui/email-template-edit-form";
import EmailTemplateSkeleton from "./skeleton/email-template-skeleton";

export default function EmailTemplateEditPage(){
     const { id } = useParams();
      const api = new EmailTemplatesService();
      const [template, setTemplate] = useState<EmailTemplate>();
      const [loading, setLoading] = useState(true);
      useEffect(() => { 
        fetchTemplate();
      }, []);
      console.log({id})
      const fetchTemplate = async () => {
        if (id) {
          const data = await api.getEmailTemplateById(id); // Placeholder for fetched features
          setTemplate(data);
          setLoading(false);
          
        }
      };

      if (!template && !loading) return <NotFound message="Feature not found." />;
    
      return (
        <main className="max-w-3xl ">
          <Breadcrumbs
            breadcrumbs={[
              { label: "Email Templates", href: "/admin/email-templates" },
              {
                label: "Edit",
                href: `/admin/email-templates/edit/${id}`,
                active: true,
              },
            ]}
          />
          {!loading && template ? (
            <EmailTemplateEditForm template={template} />
          ) : (
            <EmailTemplateSkeleton />
          )}
        </main>
      );
    }
    